/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of the integrity check performed on the device.
 */
export enum DeviceIntegrityCheckStatusType {
  DeviceIntegrityCheckStatusUnknown = 'Unknown',
  DeviceIntegrityCheckStatusUnsupported = 'Unsupported',
  DeviceIntegrityCheckStatusFailed = 'Failed',
  DeviceIntegrityCheckStatusVerified = 'Verified',
}
